import { useState } from "react"
import { Link } from "react-router-dom"
import { useConsent } from "@/context/consent/consent-context"
import { Button } from "@/components/ui/button"
import { Analytics } from "@/lib/analytics"

export function CookieBanner() {
	const { status, accept, decline } = useConsent()
	const [dismissed, setDismissed] = useState(false)

	if (status !== null || dismissed) return null

	function handleAccept() {
		setDismissed(true)
		accept()
		Analytics.capture("Cookie Consent Accepted")
	}

	function handleDecline() {
		setDismissed(true)
		decline()
	}

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-4 duration-300">
			<div className="mx-auto max-w-5xl bg-white/90 dark:bg-slate-900/90 backdrop-blur-md rounded-2xl border border-sky-900/10 dark:border-sky-100/10 shadow-lg px-6 py-4">
				<div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
					<p className="flex-1 text-sm text-sky-900/80 dark:text-sky-100/70">
						We use analytics cookies to understand how BeeDiv is used and improve your experience.{" "}
						<Link
							to="/privacy"
							className="underline underline-offset-2 hover:text-sky-700 dark:hover:text-sky-300 transition-colors"
						>
							Privacy Policy
						</Link>
					</p>
					<div className="flex gap-2 shrink-0">
						<Button
							variant="outline"
							size="sm"
							onClick={handleDecline}
							className="border-sky-200 dark:border-sky-700 text-sky-900/70 dark:text-sky-100/70 hover:bg-sky-50 dark:hover:bg-slate-800"
						>
							Decline
						</Button>
						<Button size="sm" onClick={handleAccept} className="bg-sky-600 hover:bg-sky-700 text-white">
							Accept
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}
